import { Link } from 'react-router-dom';
import type { Tool } from '../data/tools';
import { trackEvent } from '../lib/analytics';

const CATEGORY_GLYPH: Record<Tool['category'], string> = {
  finance: '$',
  life: 'L',
  privacy: 'P',
  work: 'W',
  office: 'O',
  entrepreneur: 'E',
};

const CATEGORY_STYLES: Record<Tool['category'], string> = {
  finance: 'bg-brand-50 text-brand-700 ring-brand-100',
  life: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
  privacy: 'bg-rose-50 text-rose-700 ring-rose-100',
  work: 'bg-amber-50 text-amber-700 ring-amber-100',
  office: 'bg-sky-50 text-sky-700 ring-sky-100',
  entrepreneur: 'bg-violet-50 text-violet-700 ring-violet-100',
};

interface ToolCardProps {
  tool: Tool;
}

export function ToolCard({ tool }: ToolCardProps) {
  const handleClick = () => {
    trackEvent('tool_card_click', {
      slug: tool.slug,
      tier: tool.tier,
      category: tool.category,
    });
  };

  return (
    <Link
      to={`/tools/${tool.slug}`}
      onClick={handleClick}
      className="group block rounded-xl border border-slate-200 bg-white p-5 transition-shadow hover:shadow-md focus:outline-none focus:ring-2 focus:ring-brand-500"
    >
      <div className="flex items-start justify-between">
        <span
          className={`inline-flex h-9 w-9 items-center justify-center rounded-lg text-base font-semibold ring-1 ${CATEGORY_STYLES[tool.category]}`}
          aria-hidden="true"
        >
          {CATEGORY_GLYPH[tool.category]}
        </span>
        {tool.status === 'live' ? (
          <span className="rounded-full bg-emerald-500 px-2 py-0.5 text-xs font-medium text-white">
            Available
          </span>
        ) : tool.tier === 'core' ? (
          <span className="rounded-full bg-accent-500 px-2 py-0.5 text-xs font-medium text-white">
            Pro
          </span>
        ) : null}
      </div>
      <h3 className="mt-4 text-base font-semibold text-slate-900 group-hover:text-brand-700">
        {tool.name}
      </h3>
      <p className="mt-1 text-sm text-slate-500">{tool.tagline}</p>
    </Link>
  );
}